import AutomobileIcon from './AutomobileIcon'

export default AutomobileIcon
